import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BaseComponent from '../../../baseClasses/BaseComponent';
import cancelIcon from '../../../assets/images/close-icon.svg';
import anime from 'animejs';
import ComboBox from '../../../components/ComboBox';
import dataModel from '../../../models/DataModel';
import './DeleteProjectGroupPopup.scss';
import projectGroupService from '../../../services/projectGroupService';

export class DeleteProjectGroupPopup extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      groupedProject: [], // Projects in this group
      isReplacing: false,
      noReplacing: false,
      changingGroup: false,
      selectedNewGroup: null,
      projectGroups: [],
    };

    this.closePopup = this.closePopup.bind(this);
    this.collapsePopup = this.collapsePopup.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSelectGroup = this.handleSelectGroup.bind(this);
    this.handleAcceptDelete = this.handleAcceptDelete.bind(this);
    this.handleNoReplace = this.handleNoReplace.bind(this);
    this.handleChangeGroup = this.handleChangeGroup.bind(this);
  }

  componentDidMount() {
    const { currentCompany } = this.props;

    dataModel.setDisableAppBackground(true);

    projectGroupService.getProjectGroups(currentCompany.id).then(response=>{
      let projectGroups = [];
      response.data.map(pg=>{
        projectGroups.push({
          id: pg.attributes.id,
          type: pg.attributes.id,
          name: pg.attributes.name,
          projects: pg.relationships.projects.data || [],
        });
      });
      this.setState({ projectGroups });
    });
  }

  componentWillUnmount() {
    dataModel.setDisableAppBackground(false);
  }

  closePopup() {
    dataModel.setDisableAppBackground(false);
    const { handleClosePopup } = this.props;
    if (handleClosePopup) {
      handleClosePopup();
    }
  }

  collapsePopup() {
    anime({
      targets: this.deactivatePopup,
      height: 0,
      easing: 'easeInOutCubic',
      duration: 200,
      complete: () => {
        this.closePopup();
      },
    });
  }

  handleDelete() {
    if(this.props.handleDeleteGroup){
      this.props.handleDeleteGroup();
      this.closePopup();
    }
  }

  handleNoReplace() {
    this.setState({ noReplacing: true, isReplacing: false });
  }

  handleAcceptDelete() {
    this.setState({ isReplacing: true, noReplacing: false });
  }

  handleChangeGroup() {
    const { selectedNewGroup } = this.state;
    const { currentCompany, projectsList } = this.props;

    if(selectedNewGroup){
      let existingProjectsInNewGroup = [];
      if(selectedNewGroup.projects.length > 0){
        existingProjectsInNewGroup = selectedNewGroup.projects.map(project => project.id);
      }

      let projectsIds = [...existingProjectsInNewGroup, ...projectsList];
      projectGroupService.updateProjectGroup(selectedNewGroup.id, currentCompany.id, selectedNewGroup.name, projectsIds);
      // After change the group deleting thwe group
      this.handleDelete();
    }
  }

  handleSelectGroup(groupId) {
    const selectedGroupId = groupId;
    const selectedGroup = this.state.projectGroups.find(group => group.id == selectedGroupId);
    this.setState({ selectedNewGroup: selectedGroup });
  }

  render() {
    const { haveProjects, projectGroup } = this.props;
    const { isReplacing, noReplacing, changingGroup, selectedNewGroup, projectGroups } = this.state;
  
    // Filter out the project group from props (projectGroup)
    const filteredProjectGroups = projectGroups.filter(group => group.id != projectGroup.id);
  
    let infoText = '';
  
    if (haveProjects && !isReplacing && !noReplacing) {
      infoText = `${projectGroup.name.toUpperCase()} has projects. Do you want to change their group before deleting?`;
    } else if (isReplacing && !changingGroup) {
      infoText = 'Please select the group to move the projects to:';
    } else if (noReplacing) {
      infoText = 'If you don\'t change the group, the projects will remain without any group.';
    } else if (!haveProjects) {
      infoText = `You are about to delete ${projectGroup.name.toUpperCase()} group. Do you wish to continue?`;
    }
  
    return (
      <div className="delete-project-group-background">
        <div className="delete-project-group" ref={el => (this.deactivatePopup = el)}>
          <header className="delete-project-group__header" style={{ backgroundColor: '#184E78' }}>
            <div className="caption" style={{ color: 'white' }}>
              Delete Project Group
            </div>
            <div className="close-button">
              <img
                src={cancelIcon}
                alt="cancel"
                className="close-button"
                onClick={this.collapsePopup}
              />
            </div>
          </header>
  
          <div className="delete-project-group__container">
            {infoText && (
              <div className="delete-group-text">
                {infoText}
              </div>
            )}
  
            {isReplacing && !changingGroup && (
              <div className="group-select-container">
                <ComboBox 
                  id={'groupPicker'} 
                  options={filteredProjectGroups} 
                  multiSelect={false}
                  hasBorder={true} 
                  underlined={false} 
                  width={217}
                  height={32} 
                  displayFontStyle={{ fontSize: '14px' }} 
                  handleSelection={this.handleSelectGroup}
                  placeHolderText={'Market'} 
                />
              </div>
            )}
  
            {haveProjects && !isReplacing && !noReplacing && (
              <div className="delete-project-group__button-container">
                <button className="cancel-button" onClick={this.collapsePopup}>CANCEL</button>
                <button className="delete-button" onClick={this.handleNoReplace}>NO</button>
                <button className="yes-button" onClick={this.handleAcceptDelete}>YES</button>
              </div>
            )}
  
            {(noReplacing || !haveProjects) && (
              <div className="delete-project-group__button-container">
                <button className="cancel-button" onClick={this.collapsePopup}>CANCEL</button>
                <button className="delete-button" onClick={this.handleDelete}>DELETE</button>
              </div>
            )}
  
            {isReplacing && !changingGroup && (
              <div className="delete-project-group__button-container">
                <button className="cancel-button" onClick={this.collapsePopup}>CANCEL</button>
                <button className={`delete-button ${!selectedNewGroup ? 'inactive' : ''}`} onClick={selectedNewGroup && this.handleChangeGroup}>REPLACE & DELETE</button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default withRouter(connect(mapStateToProps)(DeleteProjectGroupPopup));



// WEBPACK FOOTER //
// ./src/containers/ProjectSummaryContainer/DeleteProjectGroupPopup/index.js